import { USER_TYPE } from './user-type';

export const USER_ROLE = {
  PFS_ADMIN: [USER_TYPE.STAFF, USER_TYPE.MANAGER, USER_TYPE.ADMIN],
  GROUP_ADMIN: [USER_TYPE.ELEARNING_MANAGER],
  STUDENT: [USER_TYPE.ELEARNING_STUDENT],
  SME: [USER_TYPE.SME],
};
